module.exports = __webpack_public_path__ + "img/Number=70.866cf188.png";